import React from 'react'
import { Box } from '@mui/material'
import Image from '../../../assets/images/about/market-researcher - Copy.jpg'

function ImageContainer() {
  return (
    <Box sx={{ width: '100%' }} >
      <Box component="img" src={Image} sx={{ width: '100%' }} />
    </Box>
  )
}

export default ImageContainer
